<template>

  <v-card
    max-width="205"
  >
      <v-card-text class="justify-end mb-n4" style="font-size:1.0em" >
        Delivered Email(s)
      </v-card-text>

      <v-card-text>
          <div class ="text-end font-weight-bold" style="font-size:1.0em">
            {{ delivered }}
          </div>
      </v-card-text>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex'
// import axios from 'axios'

export default {
  name: 'DeliveredEmail',
  computed: {
    ...mapGetters({
      delivered: 'count_delivered'
    })
  }
}
</script>
